module.exports = __webpack_public_path__ + "assets/img/krawatte-orange.6973ff1f.jpg";